<template>
  <div class="books-container">
    <div class="bootstrap-wrapper">
      <div class="container">
        <!-- <div class="row hidden-row"></div> -->
        <div class="row">
          <div class="col-12 my-5">
            <h5>
              <unicon
                :name="'books'"
                :fill="secCol"
                style="margin-right: 8px;"
              />
              <span>Mantenedor</span>
            </h5>
          </div>
        </div>
        <div class="row pb-4">
          <!-- <div class="col-md-3">
            <img src="https://placehold.it/100x100" />
          </div> -->
          <div class="col-md-9">
            <div class="row">
              <div class="col-12 h5 text-logo">
                Administre sus libros asignados
              </div>
            </div>
            <div class="row">
              <div class="col-md-8 subtitle">
                <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce
                vel lobortis nisl. In id cursus neque, sed luctus leo. -->
              </div>
            </div>
            <div class="row mt-4">
              <!-- <div class="col-md-6">
                <CustomInput :icon="'fa fa-search'">
                  <input
                    type="text"
                    slot="input"
                    placeholder="Buscar libro por título"
                    v-model="bookTitle"
                    @change="filter"
                  />
                </CustomInput>
              </div> -->
              <div class="col-md-6">
                <DropSelect
                  :disabled="showSpinner"
                  v-bind="selectCourse"
                  v-model="selectCourse.selected"
                  :zIndex="3"
                />
                <!-- <span
                  class="text-gray"
                  v-if="!selectCourse.selected || selectCourse.selected <= 0"
                >
                  Selecciona curso para visualizar libros asignados
                </span> -->
              </div>
              <!-- <div class="col-md-6">
                <CustomInput :icon="'fa fa-filter'">
                  <input type="text" slot="input" placeholder="Filtrar por" />
                </CustomInput>
              </div> -->
            </div>
          </div>
        </div>

        <div class="row" v-if="books.length">
          <template v-for="(book, i) in books">
            <div class="scene-bee-flip scene--card-bee-flip pb-4" :key="i">
              <div class="card-bee-flip" :id="'card_' + i">
                <div class="card__face-bee-flip card__face--front-bee-flip">
                  <BookCard
                    @deleteBook="deleteBook"
                    isMaintainer="true"
                    :key="i"
                    :data="book.book"
                    :assignationData="book"
                    @toggleCard="toggleCard(i)"
                  />
                </div>
                <div class="card__face-bee-flip card__face--back-bee-flip">
                  <div class="col-12">
                    <div
                      class="elevation-2 radius-5 box mx-auto px-3 pb-3"
                      style="height: 363px;"
                    >
                      <div
                        class="font-weight-bold card-title text-center"
                        style="min-height: 0;"
                      >
                        <span class="d-inline-block">
                          Detalles de la asignación
                        </span>
                        <span class="d-inline-block float-right">
                          <i
                            class="fas fa-times text-muted pointer"
                            style="font-size: 22px;"
                            @click="toggleCard(i)"
                          ></i>
                        </span>
                      </div>
                      <div class="d-flex justify-content-around pt-2 pb-3">
                        <span>
                          <strong>
                            Fecha inicial
                          </strong>
                          <br />
                          {{ book.startingDate.substring(0, 10) }}
                        </span>
                        <span>
                          <strong>
                            Fecha final
                          </strong>
                          <br />
                          {{ book.evaluationDate.substring(0, 10) }}
                        </span>
                      </div>
                      <div class="row">
                        <div class="col-12 text-center">
                          <strong
                            class="text-barlow-condensed h5 small text-dark"
                            >Porcentaje de páginas leídas</strong
                          >
                        </div>
                      </div>
                      <div class="row">
                        <div class="mx-auto col-md-12 text-center">
                          <div class="progress">
                            <span class="progress-value"
                              >{{ book.progressPercentage }}%</span
                            >
                            <div
                              class="progress-bar bg-warning"
                              role="progressbar"
                              :style="{
                                width: book.progressPercentage + '%',
                                'border-radius': '10px',
                              }"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div class="row pt-2">
                        <div class="col-12 text-center">
                          <strong
                            class="text-barlow-condensed h5 small text-dark"
                            >Porcentaje de respuestas correctas</strong
                          >
                        </div>
                      </div>
                      <div class="row">
                        <div class="mx-auto col-md-12 text-center">
                          <div class="progress">
                            <span class="progress-value"
                              >{{ book.correctAnswerPercentage }}%</span
                            >
                            <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="{
                                width: book.correctAnswerPercentage + '%',
                                'border-radius': '10px',
                              }"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12 text-center d-flex justify-content-around pt-4"
                      >
                        <button
                          class="button primary m-0 py-2"
                          @click="confirmDelete(book)"
                        >
                          Eliminar
                        </button>
                        <button
                          class="button logo m-0 py-2"
                          @click="openBookModal(book)"
                        >
                          Editar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="row" v-if="showSpinner">
          <div class="col-12 text-center">
            <Spinner />
          </div>
        </div>
        <div
          class="row"
          style="padding-top: 50px;"
          v-if="!selectCourse.selected || selectCourse.selected <= 0"
        >
          <div class="col text-center">
            Selecciona curso para visualizar libros asignados
          </div>
        </div>

        <!-- <Pagination
          :currentPage="currentPage"
          :totalPages="totalPages"
          :sizeList="sizeList"
          v-if="books.length"
          @setPage="setPage"
          @setSize="setSize"
        /> -->

        <div class="row">
          <FooterComponent />
        </div>

        <BookModal
          isMaintainer="true"
          :data="modalData.data"
          :assignationData="modalData.assignationData"
          v-if="showModal.bookModal"
          @close="showModal.bookModal = false"
          @updateBook="updateBook"
        />
        <DeleteModal
          v-if="showModal.deleteModal"
          title="Desea eliminar esta asignación?"
          @close="closeModal"
          @delete="deleteCourseBook"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import CustomInput from "@/components/CustomInput";
import FooterComponent from "@/components/Footer";
import BookCard from "@/components/Books/BookCard";
// import Pagination from "@/components/Pagination";
import BookModal from "@/components/Books/BookModal";
import Spinner from "@/components/Spinner";
import DropSelect from "@/components/DropSelect";
import DeleteModal from "@/components/Books/DeleteModal";

export default {
  name: "BooksMaintainer",
  components: {
    // CustomInput,
    FooterComponent,
    BookCard,
    DeleteModal,
    // Pagination,
    BookModal,
    Spinner,
    DropSelect,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      deleteAssignation: null,
      showSpinner: false,
      secCol,
      showModal: {
        bookModal: false,
        deleteModal: false,
      },
      books: [],
      currentPage: 0,
      totalPages: null,
      sizeList: 10,
      modalData: {
        data: null,
        assignationData: null,
      },
      bookTitle: "",
      selectCourse: {
        options: [],
        selected: undefined,
        placeholder: "Seleccione Curso o Sección",
        supTitle: "Curso o Sección",
        id: "curso",
        icon: "graduation-hat",
        valueKey: "id",
        textKey: "name",
      },
    };
  },
  computed: {
    ...mapState(["dataUrl", "teacherData", "userData", "courseList"]),
  },
  watch: {
    "selectCourse.selected"() {
      this.getBooksList();
    },
    courseList() {
      this.getCourses();
    },
    // userData() {
    //   this.getFilters();
    // },
  },
  methods: {
    closeModal() {
      this.showModal.deleteModal = false;
    },
    confirmDelete(data) {
      this.deleteAssignation = data;
      this.showModal.deleteModal = true;
    },
    async deleteCourseBook() {
      const apiUrl = `${this.dataUrl}/courseBook/deleteCourseBook`;
      const params = new URLSearchParams(`id=${this.deleteAssignation.id}`);

      let loader = this.$loading.show();

      try {
        let { data } = await this.axios.delete(apiUrl, { params });

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.deleteBook(this.deleteAssignation.id);
          this.showModal.deleteModal = false;
          this.$notify({
            title: ["Se ha borrado la asignación de libro"],
            type: "success",
          });
        } else {
          this.$notify({
            title: ["Ocurrio un error"],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrio un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
    toggleCard(i) {
      const element = document.getElementById("card_" + i);
      element.classList.toggle("is-flipped");
    },
    deleteBook(id) {
      const indexOfBookToDelete = this.books.findIndex(book => book.id === id);
      if (indexOfBookToDelete >= 0) {
        this.books.splice(indexOfBookToDelete, 1);
        this.toggleCard(indexOfBookToDelete);
      }
    },
    updateBook(updateData) {
      if (this.modalData.assignationData.course.id !== updateData.course.id) {
        this.deleteBook(updateData.id);
      } else {
        this.modalData.assignationData.startingDate = updateData.startingDate;
        this.modalData.assignationData.evaluationDate =
          updateData.evaluationDate;
      }
    },
    getCourses() {
      if (this.courseList && this.courseList.length > 0)
        this.selectCourse.options = this.courseList;
    },
    // filter() {
    //   this.currentPage = 0;
    //   this.getBooksList();
    // },
    openBookModal(data) {
      this.modalData.data = data.book;
      this.modalData.assignationData = data;
      this.showModal.bookModal = true;
    },
    // setPage(page) {
    //   this.currentPage = page;
    //   this.getBooksList();
    // },
    // setSize(size) {
    //   this.sizeList = size;
    //   this.currentPage = 0;
    //   this.getBooksList();
    // },
    // userId=${this.teacherData.id}&
    async getBooksList() {
      if (!this.selectCourse.selected || this.selectCourse.selected <= 0)
        return;
      this.showSpinner = true;
      let apiUrl = `${this.dataUrl}/courseBook/getListByCourseId?courseId=${this.selectCourse.selected}`;
      this.books = [];

      try {
        let { data } = await this.axios.get(apiUrl);
        this.books = data.content;
      } catch {
        // this.getBooksList();
      } finally {
        this.showSpinner = false;
      }
    },
    // async getFilters() {
    //   let apiUrl = `${this.dataUrl}/course/getAllGradeByCountryId?countryId=${this.userData.school.baseCountryId}`;

    //   try {
    //     let { data } = await this.axios.get(apiUrl);

    //     if (data.status.name.toLocaleLowerCase() == "ok") {
    //       this.selectCourse.options = data.content;

    //       this.selectCourse.options.unshift({
    //         ordinalGrade: "",
    //         name: "Todos",
    //       });
    //     } else {
    //       this.$notify({
    //         title: ["Ocurrió un error"],
    //         type: "danger",
    //       });
    //     }
    //   } catch {
    //     this.$notify({
    //       title: ["Ocurrió un error"],
    //       type: "danger",
    //     });
    //   }
    // },
  },
  mounted() {
    this.getCourses();
    this.getBooksList();
  },
};
</script>

<style lang="scss" scoped>
.books-container {
  min-height: calc(100vh - 304px);
}

.subtitle {
  font-size: 14px;
}

.scene-bee-flip {
  width: 300px;
  height: 400px;
  perspective: 2000px;
}

.card-bee-flip {
  width: 100%;
  height: 100%;
  transition: transform 1s;
  transform-style: preserve-3d;
  cursor: auto;
  position: relative;
}

.card-bee-flip.is-flipped {
  transform: rotateY(180deg);
}

.card__face-bee-flip {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.card__face--front-bee-flip {
  background: white;
}

.card__face--back-bee-flip {
  background: white;
  transform: rotateY(180deg) translateZ(1px);
}

.progress {
  border-radius: 10px;
  height: 20px;
  font-size: 15px;
  text-align: center;
}

.progress-value {
  position: absolute;
  right: 0;
  left: 0;
}
</style>
